const STORAGE_KEY = "rpo:candidate-import-work";
export const CANDIDATE_IMPORT_WORK_EVENT = "rpo:candidate-import-work";

export function readCandidateImportWork() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function writeCandidateImportWork(nextState) {
  const state = {
    ...(readCandidateImportWork() || {}),
    ...(nextState && typeof nextState === "object" ? nextState : {}),
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Candidate creation must continue if browser storage is unavailable.
  }

  window.dispatchEvent(
    new CustomEvent(CANDIDATE_IMPORT_WORK_EVENT, { detail: { state } })
  );
  return state;
}

export function clearCandidateImportWork() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  window.dispatchEvent(
    new CustomEvent(CANDIDATE_IMPORT_WORK_EVENT, { detail: { state: null } })
  );
}
